import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LanguageUtil } from '../../shared/util/language-util';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})

export class DemonstracaoService {
    url: string = environment.url + 'DocumentSend.do';

    constructor(
        private httpClient: HttpClient,
        private translate: TranslateService
    ) {
    }

    enviarEmail(
        index,
        nomeCompleto,
        email,
        celular,
        empresa,
        cargo) {

        const locale = LanguageUtil.retornaLanguage(this.translate.currentLang);

        let body = new HttpParams();
        body = body.set('metodo', 'generateAndSend')
            .set('index', index)
            .set('locale', locale)
            .set('nomeCompleto', nomeCompleto)
            .set('email', email)
            .set('celular', encodeURI(celular))
            .set('empresa', empresa)
            .set('cargo', cargo);

        return this.httpClient.post(this.url, body);
    }
}
